const variants = {
  h1: {
    color: "text-color",
    fontSize: "h1",
    lineHeight: "120%",
    fontWeight: "medium",
  },
  h2: {
    color: "text-color",
    fontSize: "h2",
    lineHeight: "120%",
    fontWeight: "medium",
  },
  h3: {
    color: "text-color",
    fontSize: "h3",
    lineHeight: "120%",
    fontWeight: "medium",
  },
  h4: {
    color: "text-color",
    fontSize: "h4",
    lineHeight: "120%",
    fontWeight: "medium",
  },
  h5: {
    color: "text-color",
    fontSize: "h5",
    lineHeight: "120%",
    fontWeight: "medium",
  },
  h6: {
    color: "text-color",
    fontSize: "h6",
    lineHeight: "120%",
    fontWeight: "medium",
  },
  body: {
    color: "lighter-text-color",
    fontSize: "body",
    lineHeight: "140%",
    fontWeight: "normal",
  },
  "body-medium": {
    color: "lighter-text-color",
    fontSize: "body-medium",
    lineHeight: "140%",
    fontWeight: "normal",
  },
  "body-medium-14": {
    color: "text-color",
    fontSize: "body-small",
    lineHeight: "120%",
    fontWeight: "medium",
  },
  "body-large": {
    color: "lighter-text-color",
    fontSize: "body-large",
    lineHeight: "140%",
    fontWeight: "normal",
  },
  "body-small": {
    color: "lighter-text-color",
    fontSize: "body-small",
    lineHeight: "140%",
    fontWeight: "normal",
  },
  // all variants below are legacy and should not be used
  "body-lg": {
    color: "lighter-text-color",
    fontSize: "body-lg",
    lineHeight: "140%",
    fontWeight: "normal",
  },
  label: {
    color: "lighter-text-color",
    fontSize: "label",
    lineHeight: "140%",
    fontWeight: "medium",
  },
  caption: {
    color: "lighter-text-color",
    fontSize: "caption",
    lineHeight: "140%",
    fontWeight: "semiBold",
  },
};
export default variants;
